import { UserDto } from "@/shared/dtos/user-dto";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";

interface MenuItem {
	id: string;
	text: string;
	i18n: string;
	link?: string;
	href?: string | null;
	target?: string | null;
	icon?: string;
	items?: MenuItem[];
	contextItems?: MenuItem[];
}

interface UserState {
	users: UserDto[];
	user: UserDto | undefined;
	userPanel: MenuItem[];
}

const initialState: UserState = {
	users: [],
	user: undefined,
	userPanel: [],
};

export const selectUserPanelItems = (state: RootState) => state.user.userPanel;

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setUsers(state, action: PayloadAction<UserDto[]>) {
			state.users = action.payload;
		},
		setUser(state, action: PayloadAction<UserDto>) {
			state.user = action.payload;
		},
		setUserPanel(state, action: PayloadAction<MenuItem[]>) {
			state.userPanel = action.payload;
		},
	},
});

export const { setUsers, setUser, setUserPanel } = userSlice.actions;
export default userSlice;
